import { transformMatchResponse, } from './matchTransformUtil';
import { getDateByTime, } from '../../jsCore/utils/date';
import { getLeagueNames, getLeagueName2Id, } from './leagueTransformUtil';
import { flatten, } from '../../jsCore/utils/array';
function flattenedMatches2data(flattened){
  const date2Matches = {};
  const ret = [];
  for (let i = 0; i < flattened.length; i++){
    const match = flattened[i];
    const { leagueId, matchDate: date, } = match;
    const key = date.toDateString();
    if (!date2Matches[key]) {
      date2Matches[key] = {
        date: date,
        dayMatches: []
      };
      ret.push(date2Matches[key]);
    }
    let todaysLeaguesMatches = date2Matches[key];
    let leagueDayMatches = todaysLeaguesMatches.dayMatches.find(m => m.leagueId === leagueId);
    if (!leagueDayMatches) {
      leagueDayMatches = { leagueId, matches: [match.match] };
      todaysLeaguesMatches.dayMatches.push(leagueDayMatches);
    } else {
      leagueDayMatches.matches.push(match.match);
    }
  }
  return ret;
}
function getLeagueDayMatches(matchesList, leagueId){
  return flatten(matchesList.map((dayMatches) => {
    const { date, } = dayMatches;
    let { matches, } = dayMatches.dayMatches.find(currentleagueDayMatches =>
        currentleagueDayMatches.leagueId === leagueId) || { matches: [] };
    let matchesClean = matches.map(transformMatchResponse);
    return { day: date, matches: matchesClean, };
  }));
}
function mapMatchesToMatchesWithDateAndNoTime({ match, leagueId, }){
  const { start_time: matchDateEpoch, } = match;
  const matchDate = getDateByTime(new Date(matchDateEpoch * 1000));
  return { match, leagueId, matchDate };
}
function getCurrentLeagueDayMatches(leagueDayMatches){
  const { league_id: leagueId, } = leagueDayMatches;
  return leagueDayMatches.matches
    .map(match => mapMatchesToMatchesWithDateAndNoTime({ match, leagueId, }));
}
function getAllLeaguesDayMatches(dm){
  const { day_matches: currLeagueDayMatchesList, } = dm;
  return flatten(currLeagueDayMatchesList.map(getCurrentLeagueDayMatches));
}
function getMatchesWithFixedDates({ matches: matchesByDay, }){
  const ret = flatten(matchesByDay.map(getAllLeaguesDayMatches));
  return ret;
}
function mapLeagueName2LeagueData({ leagueName, leagueId, dayMatchesList, }){
  return {
    leagueName,
    leagueId,
    leagueDayMatches: getLeagueDayMatches(dayMatchesList, leagueId)
  };
}
export function transformMatchResponseToFixturesSchedule(matchesData){
  const dataWithFixedDates = getMatchesWithFixedDates(matchesData);
  const dayMatchesList = flattenedMatches2data(dataWithFixedDates);
  const leagueName2Id = getLeagueName2Id();
  const leagueNames = getLeagueNames();
  const leaguesData = leagueNames.map(leagueName =>
      mapLeagueName2LeagueData({ leagueName, leagueId: leagueName2Id[leagueName], dayMatchesList, }));
  return {
    matches: {
      matchesByLeague: leaguesData,
      leagueNamesForSelection: leagueNames,
    }
  };
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/scheduleScoresTransformUtil.js